import { Corners } from '../types';

export const getCornersStyle = (corners?: Corners) =>
  corners ? { borderRadius: `${corners === 'pill' ? '20px' : corners === 'rounded' ? '4px' : 0}` } : {};
